<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2023-01-03 11:46:01
 * @LastEditTime: 2023-01-03 13:35:28
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <my-popconfirm
        :width="width"
        :title="title"
        :placement="placement"
        :confirm-button-text="confirmButtonText"
        :confirm-button-type="confirmButtonType"
        @onConfirm="onConfirm"
    >
        <ux-button type="danger" text slot="reference">{{ text }}</ux-button>
    </my-popconfirm>
</template>
<script>

import myPopconfirm from '@c/myPopconfirm/myPopconfirm';
export default {
  name: 'DelRulePop',
  components: {
    myPopconfirm
  },
  props: {
    width: {
      type: String,
      default: '150px'
    },
    title: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      confirmButtonText: this.$t('HT.delete'),
      confirmButtonType: 'danger'
    };
  },
  methods: {
    onConfirm() {
      this.$emit('on-confirm');
    }
  }
};
</script>
